import { ActionTypes } from "./actionType";
import { AuthActionTypes } from "./types";
import { User } from "firebase/auth";

export const setUser = (user: User | null): AuthActionTypes => {
  return {
    type: ActionTypes.setUserInfo,
    payload: {
      User: user,
    },
  };
};
